var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useState } from 'react';
import { gotoLogonModule } from '../../components/Utils';
import { accountApi } from '../../api/common/account';
// eslint-disable-next-line @typescript-eslint/no-var-requires
var base64 = require('base-64');
var PerksRedeemContext = createContext(null);
var PerksRedeemProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(null), perksRedeem = _b[0], setPerksRedeem = _b[1];
    var _c = useState(false), hasPerksRedeemError = _c[0], setHasPerksRedeemError = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(''), decodedBarcode = _e[0], setDecodeBarcode = _e[1];
    var _f = useState(''), decodedGiftCardPin = _f[0], setDecodedGiftCardPin = _f[1];
    var barcodeSetup = function (encodedString) {
        var decoded = '';
        if (encodedString !== undefined && encodedString.length > 0) {
            decoded = base64.decode(encodedString);
        }
        return decoded;
    };
    var clearPerksRedeemData = function () {
        setPerksRedeem(null);
    };
    var getPerksRedeemData = React.useCallback(function (requestData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsLoading(true);
            return [2 /*return*/, accountApi
                    .perksRedeemDetails(requestData)
                    .then(function (data) {
                    var _a;
                    if ((data === null || data === void 0 ? void 0 : data.status) === 401 || (data === null || data === void 0 ? void 0 : data.status) === 431) {
                        gotoLogonModule();
                    }
                    if (((_a = data === null || data === void 0 ? void 0 : data.errors) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        setHasPerksRedeemError(true);
                    }
                    else {
                        setPerksRedeem(data);
                        setDecodeBarcode(barcodeSetup(data === null || data === void 0 ? void 0 : data.barCode));
                        setDecodedGiftCardPin(barcodeSetup(data === null || data === void 0 ? void 0 : data.pin));
                    }
                    setIsLoading(false);
                })
                    .catch(function (err) {
                    setHasPerksRedeemError(true);
                    setIsLoading(false);
                })];
        });
    }); }, []);
    return (React.createElement(PerksRedeemContext.Provider, { value: {
            hasPerksRedeemError: hasPerksRedeemError,
            setHasPerksRedeemError: setHasPerksRedeemError,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            perksRedeem: perksRedeem,
            getPerksRedeemData: getPerksRedeemData,
            setPerksRedeem: setPerksRedeem,
            decodedBarcode: decodedBarcode,
            setDecodeBarcode: setDecodeBarcode,
            decodedGiftCardPin: decodedGiftCardPin,
            setDecodedGiftCardPin: setDecodedGiftCardPin,
            clearPerksRedeemData: clearPerksRedeemData,
        } }, children));
};
export { PerksRedeemProvider, PerksRedeemContext };
